export const SystemGorod = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.66265 6.60862V7.77433H5.61661V8.28433H7.67129V7.77433H9.35905V9.37719H11.1202V8.06576L9.87272 6.60862H7.67129V6.17148H7.15762V4.86005H7.67129V5.22433H8.99215V4.05862H4.66265V5.22433H5.91013V4.86005H6.4238V6.17148H5.61661V6.60862H4.66265Z"
      fill="#302E2E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0555 9.37719H19.6324V7.92005L17.9447 6.17148V5.29719H18.8252V6.17148H20.1461V4.86005L18.8252 4.05862L14.936 3.98576L13.6152 4.86005V6.17148H14.936V5.29719H15.7432V6.17148L14.0555 7.92005V9.37719ZM16.0347 8.28433C15.8737 8.28433 15.7432 8.15386 15.7432 7.99291V6.90005C15.7432 6.7391 15.8737 6.60862 16.0347 6.60862H17.6532C17.8142 6.60862 17.9447 6.7391 17.9447 6.90005V7.99291C17.9447 8.15386 17.8142 8.28433 17.6532 8.28433H16.0347ZM16.1835 5.29719L16.8439 5.73433L17.5044 5.29719V4.86005H16.1835V5.29719Z"
      fill="#302E2E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5231 12.7286V14.4772L14.2022 17.1V18.3386L15.5231 20.0143H18.0914L19.4123 18.3386V17.1L18.0914 14.4772V12.7286H17.2109V12.2915H16.3303V12.7286H15.5231ZM15.5231 18.3386V17.1H15.89V15.7886H16.3303V17.1H17.2109V15.7886H17.6511V17.1H18.0914V18.3386H15.5231Z"
      fill="#302E2E"
    />
    <path
      d="M10.3864 19.65L10.8267 19.14V17.5372V13.6758L10.3864 13.1658H10.0195L9.5792 13.6758V14.04V14.9143V17.9015V18.8486V19.14L10.0195 19.65H10.3864Z"
      fill="#302E2E"
    />
    <path d="M9.5792 14.04H9.13891V14.9143H9.5792V14.04Z" fill="#302E2E" />
    <path d="M7.89143 14.04H7.37776V14.9143H7.89143V14.04Z" fill="#302E2E" />
    <path
      d="M6.93747 19.65L7.37776 19.14V18.8486V17.9015V14.9143V14.04V13.6758L6.93747 13.1658H6.57057L6.13028 13.6758V14.04V17.9743V18.8486V19.14L6.57057 19.65H6.93747Z"
      fill="#302E2E"
    />
    <path
      d="M5.17632 19.65L5.61661 19.14V18.8486V17.9743V14.9143V14.04V13.6758L5.17632 13.1658H4.80941L4.36913 13.6758V14.9143V19.14L4.80941 19.65H5.17632Z"
      fill="#302E2E"
    />
    <path
      d="M4.36913 14.9143V13.6758H3.92884V14.9143H4.36913Z"
      fill="#302E2E"
    />
    <path d="M6.13028 14.04H5.61661V14.9143H6.13028V14.04Z" fill="#302E2E" />
    <path
      d="M5.61661 18.8486H6.13028V17.9743H5.61661V18.8486Z"
      fill="#302E2E"
    />
    <path
      d="M7.37776 18.8486H7.89143V17.9015H7.37776V18.8486Z"
      fill="#302E2E"
    />
    <path d="M9.13891 18.8486H9.5792V17.9015H9.13891V18.8486Z" fill="#302E2E" />
    <path d="M10.8267 19.14H11.267V17.5372H10.8267V19.14Z" fill="#302E2E" />
    <path
      d="M8.69862 19.65L9.13891 19.14V18.8486V17.9015V14.9143V14.04V13.6758L8.69862 13.1658H8.33172L7.89143 13.6758V14.04V14.9143V17.9015V18.8486V19.14L8.33172 19.65H8.69862Z"
      fill="#302E2E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.80078 18.7029C1.80078 20.6343 3.36651 22.2 5.29792 22.2H18.7036C20.6351 22.2 22.2008 20.6343 22.2008 18.7029V5.29719C22.2008 3.36577 20.6351 1.80005 18.7036 1.80005H5.29792C3.3665 1.80005 1.80078 3.36577 1.80078 5.29719V18.7029ZM2.68241 6.17148C2.68241 4.24006 4.24813 2.67433 6.17955 2.67433H11.6706L11.7511 10.98V11.4172H12.2209V10.98V2.67433H17.7486C19.6801 2.67433 21.2458 4.24006 21.2458 6.17148V10.98H12.2209V11.4172H21.2458V17.8118C21.2458 19.7212 19.7142 21.2776 17.8051 21.3085L12.2209 21.3986V11.4172H11.7511L11.854 21.3986L6.12399 21.3076C4.21448 21.2772 2.68241 19.7206 2.68241 17.8109V11.4172H11.7511V10.98H2.68241V6.17148Z"
      fill="#CA8044"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66265 7.77433V6.60862H5.61661V6.17148H6.4238V4.86005H5.91013V5.22433H4.66265V4.05862H8.99215V5.22433H7.67129V4.86005H7.15762V6.17148H7.67129V6.60862H9.87272L11.1202 8.06576V9.37719H9.35905V7.77433H7.67129V8.28433H5.61661V7.77433H4.66265ZM19.6324 9.37719V7.92005L17.9447 6.17148V5.29719H18.8252V6.17148H20.1461V4.86005L18.8252 4.05862L14.936 3.98576L13.6152 4.86005V6.17148H14.936V5.29719H15.7432V6.17148L14.0555 7.92005V9.37719H19.6324ZM15.5231 14.4772V12.7286H16.3303V12.2915H17.2109V12.7286H18.0914V14.4772L19.4123 17.1V18.3386L18.0914 20.0143H15.5231L14.2022 18.3386V17.1L15.5231 14.4772ZM10.3864 19.65L10.8267 19.14H11.267V17.5372H10.8267V13.6758L10.3864 13.1658H10.0195L9.5792 13.6758V14.04H9.13891V14.9143H9.5792V17.9015H9.13891V18.8486H9.5792V19.14L10.0195 19.65H10.3864ZM7.37776 14.04H7.89143V14.9143H7.37776V17.9015H7.89143V18.8486H7.37776V19.14L6.93747 19.65H6.57057L6.13028 19.14V18.8486H5.61661V19.14L5.17632 19.65H4.80941L4.36913 19.14V14.9143H3.92884V13.6758H4.36913L4.80941 13.1658H5.17632L5.61661 13.6758V14.04H6.13028V13.6758L6.57057 13.1658H6.93747L7.37776 13.6758V14.04ZM15.5231 17.1V18.3386H18.0914V17.1H17.6511V15.7886H17.2109V17.1H16.3303V15.7886H15.89V17.1H15.5231ZM16.0347 8.28433C15.8737 8.28433 15.7432 8.15386 15.7432 7.99291V6.90005C15.7432 6.7391 15.8737 6.60862 16.0347 6.60862H17.6532C17.8142 6.60862 17.9447 6.7391 17.9447 6.90005V7.99291C17.9447 8.15386 17.8142 8.28433 17.6532 8.28433H16.0347ZM16.8439 5.73433L16.1835 5.29719V4.86005H17.5044V5.29719L16.8439 5.73433ZM6.13028 14.9143V17.9743H5.61661V14.9143H6.13028Z"
      fill="#302E2E"
    />
  </svg>
);
